module.exports = __webpack_public_path__ + "fonts/carton-slab-webfont.9510a5c8.woff";